module.exports = __webpack_public_path__ + "img/menueurojack.763bad35.png";